export default __webpack_public_path__ + "static/media/uprofile.23e340ab.svg";